import React, { useState } from 'react';
import { PRIORITY_LEVELS, PRIORITY_LABELS } from '../../constants/cardConstants';
import {
    StatusPrioritySection,
    FieldContainer,
    FieldLabel,
    SelectButton,
    Dropdown,
    DropdownOption,
    PriorityIndicator
} from '../../styles/CardModal.styles';

const StatusPriority = ({
    allColumns,
    selectedStatus,
    selectedPriority,
    onStatusChange,
    onPriorityChange,
    columnOrder
}) => {
    const [showStatusDropdown, setShowStatusDropdown] = useState(false);
    const [showPriorityDropdown, setShowPriorityDropdown] = useState(false);

    return (
        <StatusPrioritySection>
            <FieldContainer style={{ position: 'relative' }}>
                <FieldLabel>Status</FieldLabel>
                <SelectButton onClick={() => setShowStatusDropdown(!showStatusDropdown)}>
                    {allColumns[selectedStatus]?.title || 'Select status'}
                    <span>▼</span>
                </SelectButton>
                {showStatusDropdown && (
                    <Dropdown>
                        {columnOrder.map(columnId => {
                            const col = allColumns[columnId];
                            if (!col) return null; // Or some error handling
                            return (
                                <DropdownOption
                                    key={col.id}
                                    selected={col.id === selectedStatus}
                                    onClick={() => {
                                        onStatusChange(col.id);
                                        setShowStatusDropdown(false);
                                    }}
                                >
                                    {col.title}
                                </DropdownOption>
                            );
                        })}
                    </Dropdown>
                )}
            </FieldContainer>

            <FieldContainer style={{ position: 'relative' }}>
                <FieldLabel>Priority</FieldLabel>
                <SelectButton onClick={() => setShowPriorityDropdown(!showPriorityDropdown)}>
                    <PriorityIndicator priority={selectedPriority}>
                        {PRIORITY_LABELS[selectedPriority]?.label}
                    </PriorityIndicator>
                    <span>▼</span>
                </SelectButton>
                {showPriorityDropdown && (
                    <Dropdown>
                        {Object.entries(PRIORITY_LEVELS).map(([key, value]) => (
                            <DropdownOption
                                key={value}
                                selected={value === selectedPriority}
                                onClick={() => {
                                    onPriorityChange(value);
                                    setShowPriorityDropdown(false);
                                }}
                            >
                                <PriorityIndicator priority={value}>
                                    {PRIORITY_LABELS[value].label}
                                </PriorityIndicator>
                            </DropdownOption>
                        ))}
                    </Dropdown>
                )}
            </FieldContainer>
        </StatusPrioritySection>
    );
};

export default StatusPriority;